interface Release {
  version: string;
  name: string;
  summary: string;
}

const RELEASES: Release[] = [
  { version: 'v14.0.2', name: 'Ashoka', summary: 'DreamGraph browser backend for Codex CLI and native API routes, native Windows Save/Open dialogs, explicit browser-extension connection, observed task reporting, conversation recovery and context-cost fixes. Linux/macOS native dialogs remain operator actions.' },
  { version: 'v14.0.1', name: 'Ashoka', summary: 'First field patch: legacy graph migration preserves earlier revisions, Codex CLI Computer Use attempts bounded browser cleanup and reports unconfirmed release, and validation counts agree across Status, CLI, and Explorer. Includes Architect, configuration, schedule, and session recovery fixes.' },
  { version: 'v14.0.0', name: 'Ashoka', summary: 'First practical-testing release: canonical graph contracts, bounded agent context, coherent lifecycle/recovery, role policies, configuration/schedules and governed Computer Use. Published model-quality failures; no measured understanding gain or cost-saving claim.' },
  {
    version: 'v13.2.0',
    name: 'Continuation Boundaries',
    summary: 'CLI adapters execute without Architect continuation envelopes, native API continuation stays controller-owned, and autonomous execution continues beyond intermediate checkpoints until the requested target is complete or genuinely blocked.',
  },
  {
    version: 'v13.1.0',
    name: 'Additive Scan',
    summary: 'Incremental scan completion, resumable enrichment, graph-health coverage evidence, transport benchmarks, and MCP timeout ownership.',
  },  {
    version: 'v13.0.0',
    name: 'Cognitive Maintenance',
    summary: 'Graph health, mandatory multi-hop enrichment, semantic caching, targeted dreams, PostgreSQL ownership discovery, and structured Explorer knowledge become one continuous maintenance system.',
  },
  {
    version: 'v12.6.0',
    name: 'Hippodamus',
    summary: 'The final v12 maintenance release aligned scheduler evidence, CLI adapter provenance, installer compatibility, Explorer events, and packaged artifacts.',
  },
  {
    version: 'v12.4.0',
    name: 'Hippodamus',
    summary: 'The v12 major release title continued as Hippodamus while daemon, MCP, dashboard, CLI, docs, guide, README, and packaged artifacts aligned on 12.4.0.',
  },
  {
    version: 'v12.1.0',
    name: 'Living DreamGraph',
    summary: 'Architect Pulse, dream playback, tension clustering, desire ledger, living-plan projections, and the browser-first Easy Start path.',
  },
  {
    version: 'v12.0.0',
    name: 'Hippodamus',
    summary: 'Architect became the standalone browser-based working surface. The editor-integrated surface is called the VS Code architect.',
  },
  {
    version: 'v11.0.1',
    name: 'v11 maintenance line',
    summary: 'Pre-v12 stabilization before the browser Architect release line.',
  },
  {
    version: 'v10.6.0',
    name: 'v10 maintenance line',
    summary: 'Provider, graph-quality, and platform work that carries forward into v12.',
  },
  {
    version: 'v9.0.0',
    name: 'Lattice',
    summary: 'Plugin SDK and host platform release with tools, resources, events, UI seams, and webhooks.',
  },
];

export function Versions() {
  return (
    <div className="page">
      <header className="page__header">
        <p className="eyebrow">Versions</p>
        <h1>Current release: DreamGraph v14.0.2 — Ashoka.</h1>
        <p className="lede">This patch brings the DreamGraph browser backend to Codex CLI and native API routes, with Windows dialog handling and context-cost fixes. Install, restart the instance and reload the browser extension. The setup guide covers connection and permission separately.</p>
      </header>

      <ol className="roadmap">
        {RELEASES.map((release) => (
          <li key={release.version} className="roadmap__slice roadmap__slice--shipped">
            <div className="roadmap__head">
              <span className="roadmap__version">{release.version}</span>
              <span className="roadmap__status roadmap__status--shipped">Shipped</span>
            </div>
            <h2>{release.name}</h2>
            <p className="roadmap__why">{release.summary}</p>
          </li>
        ))}
      </ol>

      <p style={{ marginTop: 24 }}>
        Full release notes live on the{' '}
        <a href="https://github.com/mmethodz/dreamgraph/releases/tag/v14.0.2" target="_blank" rel="noreferrer">v14.0.2 release tag</a> and the{' '}
        <a href="/docs/ashoka/release-notes-v14.0.2.md">site copy</a>. The{' '}
        <a href="/docs/ashoka/release-notes-v14.0.0.md">v14.0.0 notes</a> remain available.
      </p>
    </div>
  );
}
